// eslint-disable-next-line import/no-cycle
import { Dispatch, SetStateAction } from 'react'
import { LayoutQuery } from '../Layout'
import { MegaMenuHeaderTabs } from './MegaMenuHeaderTabs'
import { NewMegaMenuHeaderTabs } from './NewMegaMenuHeaderTabs'

export function MegaMenuHeader(
  props: Pick<LayoutQuery, 'menu'> & {
    value: string
    setValue: Dispatch<SetStateAction<string>>
  },
) {
  const { menu, value, setValue } = props

  return (
    <div className='flex w-[calc(100vw-20px)] items-start justify-center'>
      <NewMegaMenuHeaderTabs menu={menu} value={value} setValue={setValue} />
    </div>
  )
}
